import { STICKY_NOTES } from "../actions/utilities";

const INITIAL_STATE = {
  createStickyNoteLoading: false,
  createStickyNoteSuccess: false,
  createStickyNoteFailure: false,
  createStickyNoteError: null,
  createStickyNote: null,

  EditStickyNoteLoading: false,
  EditStickyNoteSuccess: false,
  EditStickyNoteFailure: false,
  EditStickyNoteError: null,
  EditStickyNote: null,

  getStickyNotesListLoading: false,
  getStickyNotesListSuccess: false,
  getStickyNotesListFailure: false,
  getStickyNotesListError: null,
  getStickyNotesList: [],

  deleteStickyNoteLoading: false,
  deleteStickyNoteSuccess: false,
  deleteStickyNoteFailure: false,
  deleteStickyNoteError: null,
  deleteStickyNote: null,
};

export const stickyNotesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case STICKY_NOTES.CREATE_STICKY_NOTE_REQUEST:
      return {
        ...state,
        createStickyNoteLoading: true,
        createStickyNoteSuccess: false,
        createStickyNoteFailure: false,
        createStickyNoteError: null,
      };
    case STICKY_NOTES.CREATE_STICKY_NOTE_SUCCESS:
      // let createProtocol = state.getQaProtocolList;
      // createProtocol.unshift(action.payload);
      return {
        ...state,
        createStickyNoteLoading: false,
        createStickyNoteSuccess: true,
        createStickyNoteFailure: false,
        createStickyNoteError: null,
        createStickyNote: action.payload,
        // getQaProtocolList: createProtocol,
      };
    case STICKY_NOTES.CREATE_STICKY_NOTE_FAILURE:
      return {
        ...state,
        createStickyNoteLoading: false,
        createStickyNoteSuccess: false,
        createStickyNoteFailure: true,
        createStickyNoteError: action.payload,
      };

    case STICKY_NOTES.EDIT_STICKY_NOTE_REQUEST:
      return {
        ...state,
        EditStickyNoteLoading: true,
        EditStickyNoteSuccess: false,
        EditStickyNoteFailure: false,
        EditStickyNoteError: null,
      };
    case STICKY_NOTES.EDIT_STICKY_NOTE_SUCCESS:
      // let editProtocol = state.getQaProtocolList;
      // if (editProtocol.length > 0) {
      //     for (var i = 0; i < editProtocol.length; i++) {
      //         if (editProtocol[i]._id === action.payload._id) {
      //             editProtocol[i] = action.payload;
      //         }
      //     }
      // }
      return {
        ...state,
        EditStickyNoteLoading: false,
        EditStickyNoteSuccess: true,
        EditStickyNoteFailure: false,
        EditStickyNoteError: null,
        EditStickyNote: action.payload,
        // getQaProtocolList: editProtocol,
      };
    case STICKY_NOTES.EDIT_STICKY_NOTE_FAILURE:
      return {
        ...state,
        EditStickyNoteLoading: false,
        EditStickyNoteSuccess: false,
        EditStickyNoteFailure: true,
        EditStickyNoteError: action.payload,
      };

    case STICKY_NOTES.GET_ALL_STICKY_NOTES_REQUEST:
      return {
        ...state,
        getStickyNotesListLoading: true,
        getStickyNotesListSuccess: false,
        getStickyNotesListFailure: false,
        getStickyNotesListError: null,
      };
    case STICKY_NOTES.GET_ALL_STICKY_NOTES_SUCCESS:
      return {
        ...state,
        getStickyNotesListLoading: false,
        getStickyNotesListSuccess: true,
        getStickyNotesListFailure: false,
        getStickyNotesListError: null,
        getStickyNotesList: action.payload,
      };
    case STICKY_NOTES.GET_ALL_STICKY_NOTES_FAILURE:
      return {
        ...state,
        getStickyNotesListLoading: false,
        getStickyNotesListSuccess: false,
        getStickyNotesListFailure: true,
        getStickyNotesListError: action.payload,
      };

    case STICKY_NOTES.DELETE_STICKY_NOTE_REQUEST:
      return {
        ...state,
        deleteStickyNoteLoading: true,
        deleteStickyNoteSuccess: false,
        deleteStickyNoteFailure: false,
        deleteStickyNoteError: null,
      };
    case STICKY_NOTES.DELETE_STICKY_NOTE_SUCCESS:
      return {
        ...state,
        deleteStickyNoteLoading: false,
        deleteStickyNoteSuccess: true,
        deleteStickyNoteFailure: false,
        deleteStickyNoteError: null,
        deleteStickyNote: action.payload,
      };
    case STICKY_NOTES.DELETE_STICKY_NOTE_FAILURE:
      return {
        ...state,
        deleteStickyNoteLoading: false,
        deleteStickyNoteSuccess: false,
        deleteStickyNoteFailure: true,
        deleteStickyNoteError: action.payload,
      };
    default:
      return state;
  }
};
